import APP from 'src/main.js'
import Event from './Event.js'

class FeePayment extends Event {
  get fee_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='FeeCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get income_received(){
    return (this.fee_cancel||{}).income_received
  }
  get fee_expected(){
    return (this.fee_cancel||{}).fee_expected || null
  }
  get linked(){
    return this.fee_cancel != null
  }

  // Value of the linked FeeExpected
  get matched_value() {
    return (this.fee_expected?.value || 0).toFixed(2)
  }

  // Linked and the paid value is exactly the expected value
  // (if the FeeExpected is not loaded, there is nothing to compare against)
  get is_fully_matched() {
    return this.linked && (!this.fee_expected || this.matched_value === (this.value || 0).toFixed(2))
  }

  // FeePayment should only be matched if manual_value is not true
  get should_be_linked() {
    return this.manual_value !== true
  }
}
export default FeePayment
